import { css, html, LitElement, unsafeCSS } from 'lit';
import styles from './discount.scss?inline';

export default class SotbitDiscount extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    render() {
        return html`
            <div class="sale" part="sale">
                <span class="text" part="text"><slot></slot></span>
            </div>
        `;
    }
}
